import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import PointCoinIcon from '../PointCoinIcon';


const AnimatedIconSpinningCoin = ({
    className = "",
    coinSize = "h-3 w-3 md:h-9 md:w-9",
    coinIconSize = "h-1 w-1 md:h-6 md:w-6",
    duration = 1.5
}: {
    className?: string
    coinSize?: string
    coinIconSize?: string
    duration?: number
}) => {
    return (
        <div
            className={
                cn(
                    "w-32 h-32 rounded-full bg-primary relative overflow-hidden flex flex-col items-center justify-center",
                    className
                )
            }
        >
            <motion.div
                className="flex justify-center items-center"
                animate={{ rotateY: [0, 180, 0], opacity: 1 }}
                transition={{ duration, repeat: Infinity }}
            >
                <PointCoinIcon coinSize={coinSize} coinIconSize={coinIconSize} />
            </motion.div>
        </div>
    )
}

export default AnimatedIconSpinningCoin